export default __webpack_public_path__ + "static/High-Def-Events-a322bf992e89a0d5df76cd64b03c97d0.webp";